// src/components/admin/KPICard.jsx
export default function KPICard({
  title,
  value,
  icon = "📊",
  tooltip,
  onClick,
  active = false,
  variant = "default", // "default" | "pending" | "approved" | "rejected"
}) {
  const BaseTag = onClick ? "button" : "div";
  const ariaLabel = tooltip || `${title}: ${value}`;

  const tones = {
    default:  "bg-blue-50 text-blue-700 ring-blue-100",
    pending:  "bg-amber-50 text-amber-700 ring-amber-100",
    approved: "bg-emerald-50 text-emerald-700 ring-emerald-100",
    rejected: "bg-rose-50 text-rose-700 ring-rose-100",
  };

  const interactive = !!onClick;

  return (
    <BaseTag
      type={interactive ? "button" : undefined}
      onClick={onClick}
      title={ariaLabel}
      aria-label={ariaLabel}
      aria-pressed={interactive ? !!active : undefined}
      className={[
        "w-full group relative inline-flex items-center gap-3 sm:gap-4 rounded-2xl border",
        "p-4 sm:p-5 min-h-[56px] sm:min-h-[64px] shadow-sm transition-all duration-300",
        "backdrop-blur-md",
        active
          ? "bg-gradient-to-br from-blue-600/85 to-indigo-600/85 text-white border-blue-400 shadow-lg shadow-blue-500/40"
          : "bg-white/90 border-gray-200 hover:shadow-md hover:border-blue-200",
        interactive ? "cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" : ""
      ].join(" ")}
    >
      {/* Icono */}
      <div
        className={[
          "flex h-10 w-10 sm:h-11 sm:w-11 items-center justify-center rounded-xl ring-1 transition-all duration-300 shrink-0",
          active
            ? "bg-white/20 text-white ring-white/30 shadow-inner"
            : `${tones[variant] ?? tones.default} group-hover:opacity-95`
        ].join(" ")}
        aria-hidden="true"
      >
        <span className="text-base sm:text-lg">{icon}</span>
      </div>

      {/* Texto */}
      <div className="min-w-0">
        <p className={`text-xs sm:text-sm ${active ? "text-white/85" : "text-gray-600"}`}>
          {title}
        </p>
        <p
          className={[
            "font-extrabold tracking-tight",
            "text-xl sm:text-2xl",
            active ? "text-white" : "text-blue-900",
            "transition-transform group-hover:translate-x-[0.5px]"
          ].join(" ")}
          aria-live="polite"
        >
          {value}
        </p>
      </div>

      {/* Flecha ↗ */}
      {interactive && (
        <span
          className={[
            "ml-auto select-none transition-colors text-sm sm:text-base",
            active
              ? "text-white/70 group-hover:text-white"
              : "text-gray-300 group-hover:text-gray-400"
          ].join(" ")}
          aria-hidden="true"
        >
          ↗
        </span>
      )}
    </BaseTag>
  );
}